import { ResolvedRegister } from '@wagmi/core'
import { polygon } from 'wagmi/chains'
import { createConfig, http } from 'wagmi'
import { metaMask, coinbaseWallet, walletConnect } from 'wagmi/connectors'

export interface Web3ServicesInterface {
  config: ResolvedRegister['config']
}

class Web3Service {
  config!: ResolvedRegister['config']

  constructor() {
    const projectId = process.env.REACT_APP_WALLET_CONNECT_PUBLIC_PROJECT_ID || ''
    const apiKey = process.env.REACT_APP_ALCHEMY_PROJECT_ID
    if (!apiKey && !projectId) {
      throw new Error('You need to provide REACT_KEY(s) env variable')
    }

    const chains = [polygon] as const
    this.config = createConfig({
      chains,
      transports: {
        [polygon.id]: http(`https://polygon-mainnet.g.alchemy.com/v2/${apiKey}`),
      },
      connectors: [
        coinbaseWallet({
          appName: 'primsell.com',
          preference: 'smartWalletOnly',
        }),
        metaMask(),
        walletConnect({ projectId }),
        coinbaseWallet({
          appName: 'primsell.com',
          preference: 'eoaOnly',
        }),
      ],
    })
  }

  clearConnection(): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key !== 'payment_token') {
        localStorage.removeItem(key as string)
      }
    }
  }
}

export default new Web3Service()
